import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepperDetails {
  activeStep: number;
}

const initialState: StepperDetails = {
  activeStep: 0,
};

const viewAppStepperDetailsSlice = createSlice({
  name: 'viewAppStepperDetails',
  initialState,
  reducers: {
    updateViewAppActiveStep(state, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    resetViewAppStepperDetails() {
      return { ...initialState };
    },
  },
});

export const { updateViewAppActiveStep, resetViewAppStepperDetails } =
  viewAppStepperDetailsSlice.actions;

export default viewAppStepperDetailsSlice.reducer;
